export const TYPE_RELANCE_RESET = "TYPE_RELANCE_RESET";
export const TYPE_RELANCE_SET_ERROR = "TYPE_RELANCE_SET_ERROR";
export const TYPE_RELANCE_SET_ITEMS = "TYPE_RELANCE_SET_ITEMS";
export const TYPE_RELANCE_TOGGLE_LOADING = "TYPE_RELANCE_TOGGLE_LOADING";
